module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre8"
  }, [_c('h2', {
    staticClass: "calibre7",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre9",
    attrs: {
      "id": "toi",
      "summary": "TOI"
    }
  }, [_c('tbody', {
    staticClass: "calibre10"
  }, [_c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lafcadio Hearn")]), _vm._v(" (photogravure)")]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('a', {
    staticClass: "pcalibre c",
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("Frontispiece")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "attribution"
  }, [_vm._v("From a photograph taken about 1900.")]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lafcadio Hearn")])]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('a', {
    staticClass: "pcalibre pginternal",
    attrs: {
      "href": "#/Text/Section0007#i50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "attribution"
  }, [_vm._v("From a photograph taken about 1873.")]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lafcadio Hearn and Mitchell McDonald")])]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('a', {
    staticClass: "pcalibre pginternal",
    attrs: {
      "href": "#/Text/Section0008#i110"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Lafcadio Hearn")])]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('span', {
    staticClass: "pcalibre pginternal",
    attrs: {
      "href": "#/Text/Section0010#i198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "attribution"
  }, [_vm._v("From a photograph taken in the ’70’s.")]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Facsimile of Mr. Hearn’s Earlier Handwriting")])]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('span', {
    staticClass: "pcalibre pginternal",
    attrs: {
      "href": "#/Text/Section0010#i340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Saint-Pierre and Mt. Pelée")])]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  }, [_c('span', {
    staticClass: "pcalibre pginternal",
    attrs: {
      "href": "#/Text/Section0010#i410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("410")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "attribution"
  }, [_vm._v("From a photograph in the possession of Dr. T. A. Jaggar, Jr.")]), _vm._v(" "), _c('td', {
    staticClass: "pgnumber"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0